import React, { useState, useEffect, Fragment } from "react";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Spinner from "react-bootstrap/Spinner";
import { format, subYears, addDays, isValid } from "date-fns";

//import './Statns4.css';
import { FaPrint } from "react-icons/fa";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Bunexe_service from "../../../Bunexe_service";

const Stats_par_siege = ({ code_dept, titre_ = "Moi je Teste" }) => {
  const [sieges_, setSieges_] = useState([]);
  const [eleves_, setEleves_] = useState([]);
  const [siege_, setSiege_] = useState("");
  const [startLoading, setStartLoading] = useState(false);
  const [effectifSiege, setEffectifSiege] = useState(0);
  const [mysrc, setMysrc] = useState("");
  let lesEleves = [];
  let res = [];
  // let effectifsDistrict = 0;
  let zone_temps = [];
  let zon_ = "";
  let src_ = "";
  const entete = [
    {
      NOMEL: "Nom",
      PRENOMEL: "Prenom",
      SEXE: "Sexe",
      DNAISS: "Date Naiss.",
      an_eni_ancien: "An (Eni)",
      mat_eni_ancien: "Matr (Eni)",
      session_ancien: "Anc. Session",
    },
  ];

  const entete1 = [
    {
      IDECOLE: "Code",
      DENOMEC: "Etablissement",
      Fondamentale: "Fond.",
      Prescolaire: "Presc.",
    },
  ];

  const [zones_, setZones_] = useState([]);
  const [zone_, setZone_] = useState("");
  const [displayPrintArea, setDisplayPrintArea] = useState(false);
  let nbeleve = 0;
  let LibelleSiege_temp = "";
  const url_ = Bunexe_service.url;
  //'http://localhost:8086';
  // let displayPrintArea = false;

  const formatterDate = (date__) => {
    try {
      return format(
        addDays(
          new Date(
            date__.substr(0, 10),
            // .concat('-')
            // .concat(date__.substr(4, 2))
            // .concat('-')
            // .concat(date__.substr(6, 2))
          ),
          1,
        ),
        "dd/MM/yyyy",
      );
    } catch (error) {
      return "N/A";
    }
  };

  const imprimable = () => {
    var doc = new jsPDF({ format: "letter" });
    // let dd = districts_.filter((d) => d.CodeDistrict == district_);
    let pageHeight = 0;
    // console.log(JSON.stringify(dd));
    let mydata1 = lesEleves.map((el) => {
      el.SEXE = el.SEXE == "1" ? "M" : "F";
      el.DNAISS = el.DNAISS && formatterDate(el.DNAISS);

      return el;
    });
    let mydata2 = [...mydata1];
    //let mydata2 = lesEleves;
    doc.setProperties({
      title: "Impression Ecole ",
      subject: "Liste des Inscrits ENI",
      author: "MENFP",
      keywords: "menfp, bunexe",
      creator: "BUNEXE",
    });

    var totalPagesExp = "{total_pages_count_string}";

    var pageHeight1 =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    var pageWidth1 =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    let xOffset =
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(titre_) * doc.internal.getFontSize()) / 2;
    let Tt =
      Math.ceil(doc.getStringUnitWidth(titre_) / 2) *
      doc.internal.getFontSize();
    // let str = '';

    let r6 = mydata2.reduce((res, t) => {
      res[t.DENOMEC] = res[t.DENOMEC] ? [...res[t.DENOMEC], t] : [t];
      return res;
    }, []);
    console.log("###########   PRINTABLE R6 #########");
    console.log(r6);
    let lignes = Object.keys(r6);
    doc.setFontSize(18);
    // doc.text('Dieu mon sujet de Gloire !!!', 14, 22);
    doc.setFontSize(11);
    doc.setTextColor(100);

    // jsPDF 1.4+ uses getWidth, <1.4 uses .width
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    // var text = 'Je suis celui qui vit par la grace de Dieu'; //doc.splitTextToSize(faker.lorem.sentence(45), pageWidth - 35, {})
    let str = "";
    // let pageHeight = 0;
    // doc.text(text, 14, 30);

    lignes.map((k) => {
      // doc.addPage();
      // doc.text(k + '  (' + r6[k][0].ecole + ')', 14, 30);
      // doc.text(r6[k][0].LibelleEt, 120, 30);
      // console.log(r6[k]);
      // doc.internal.
      let gg = [];
      let section_eni = [
        { section: "Fondamentale" },
        { section: "Prescolaire" },
      ];
      section_eni.map((s) => {
        gg = r6[k].filter((f) => f.section === s.section);
        //body: r6[k],
        if (gg.length > 0) {
          doc.autoTable({
            head: entete,
            body: gg,
            startY: 50,
            showHead: "everyPage",
            didDrawPage: function (data) {
              doc.setFontSize(20);
              // doc.setTextColor(100);
              //LibelleSiege_temp;
              doc.text(
                titre_.trim().toUpperCase(),
                pageWidth1 / 2 - (titre_.trim().toUpperCase().length * 4.2) / 2,
                22,
              );
              doc.setFontSize(16);
              doc.text(
                LibelleSiege_temp.trim().toUpperCase(),
                pageWidth1 / 2 -
                  (LibelleSiege_temp.trim().toUpperCase().length * 4.2) / 2,
                32,
              );
              doc.setFontSize(12);
              let An_ = "ENI / CAPISTE - 2026";
              doc.text(
                An_,
                pageWidth1 / 2 - (An_.trim().toUpperCase().length * 2.2) / 2,
                38,
              );

              //72, 38);

              doc.setFontSize(10);
              //   let serie__ = s.Libelle;
              doc.text(s.section, 170, 48);
              doc.text(`( ${gg.length} )`, 194, 48);

              //   doc.setFontSize(14);
              //   let Li_ = 'Liste des Inscrits';
              //   doc.text(Li_, pageWidth1 / 2 - (Li_.length * 3.0) / 2, 38);

              let Lig_ =
                "______________________________________________________________________";
              doc.text(Lig_, 20, 40);

              doc.setFontSize(12);
              doc.text(k.trim(), 14, 48);

              doc.setFontSize(8);
              //let dz = `District :${dd[0].libelle_district.trim()}  ==> Zone :${zon_}`;
              //doc.text(dz, pageWidth1 / 2 - (dz.length * 2.4) / 2, 36);
              //doc.text(dz, 150, 48);

              doc.setFontSize(11);

              // doc.text(
              //   ecole_selection.Ecole.trim(),
              //   pageWidth1 / 2 - (ecole_selection.Ecole.length * 3.65) / 2,
              //   38
              // );

              // doc.text(k, 14, 30);
              str = "Page " + doc.internal.getNumberOfPages();
              // Total page number plugin only available in jspdf v1.0+
              if (typeof doc.putTotalPages === "function") {
                str =
                  str +
                  " sur " +
                  totalPagesExp +
                  "     ===> Imprimé le " +
                  new Date().toISOString();
              }
              doc.setFontSize(10);

              // jsPDF 1.4+ uses getWidth, <1.4 uses .width
              var pageSize = doc.internal.pageSize;
              pageHeight = pageSize.height
                ? pageSize.height
                : pageSize.getHeight();
              doc.text(str, data.settings.margin.left, pageHeight - 10);
            },
            margin: { top: 44 },
          });
          doc.addPage();
        }
      });
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }
    // doc.text(text, 14, doc.autoTable.previous.finalY + 10);
    // document.getElementById('output').src

    src_ = doc.output("datauristring");
    //alert(src_);
    setMysrc(src_);
    document.getElementById("download-link").href = src_;
    document.getElementById("output").data = doc.output("datauristring");
  };

  const prepareData = (lesEleves) => {
    res = [];
    let k = {
      IDECOLE: "",
      DENOMEC: "",
      ADREC: "",
      Fondamentale: 0,
      Prescolaire: 0,
    };
    let d = {
      IDECOLE: "",
      DENOMEC: "",
      ADREC: "",
      Fondamentale: 0,
      Prescolaire: 0,
    };
    lesEleves.forEach((t) => {
      if (res.length == 0) {
        if (t.section === "Fondamentale") {
          k = {
            ...k,
            IDECOLE: t.IDECOLE,
            DENOMEC: t.DENOMEC,
            ADREC: t.ADREC,
            Fondamentale: t.qte_Eleves,
            Prescolaire: 0,
          };
        } else if (t.section === "Prescolaire") {
          k = {
            ...k,
            IDECOLE: t.IDECOLE,
            DENOMEC: t.DENOMEC,
            ADREC: t.ADREC,
            Prescolaire: t.qte_Eleves,
            Fondamentale: 0,
          };
        }
        res = [...res, k];
      } else if (res.length > 0) {
        d = res.findIndex((ee) => ee.IDECOLE === t.IDECOLE);
        //console.log('$$$$$$$$$$$$$   ');
        //console.log(d);
        if (d === -1) {
          if (t.section === "Fondamentale") {
            k = {
              ...k,
              IDECOLE: t.IDECOLE,
              DENOMEC: t.DENOMEC,
              ADREC: t.ADREC,
              Fondamentale: t.qte_Eleves,
              Prescolaire: 0,
            };
          } else if (t.section === "Prescolaire") {
            k = {
              ...k,
              IDECOLE: t.IDECOLE,
              DENOMEC: t.DENOMEC,
              ADREC: t.ADREC,
              Prescolaire: t.qte_Eleves,
              Fondamentale: 0,
            };
          }
          res = [...res, k];
        } else {
          // remove It from the array
          // console.log(d)
          // console.log(res[d].
          //let resTemp = res.filter((gg) => gg.IDECOLE != d.IDECOLE);
          if (t.section === "Fondamentale") {
            res[d].Fondamentale = t.qte_Eleves;
            //resTemp = [...resTemp, { ...d, Fondamentale: t.qte_Eleves }];
          } else if (t.section === "Prescolaire") {
            res[d].Prescolaire = t.qte_Eleves;
            //resTemp = [...resTemp, { ...d, Prescolaire: t.qte_Eleves }];
          }
          //res = [...resTemp];
        }
      }
    });
  };

  const imprimable1 = () => {
    var doc = new jsPDF({ format: "letter" });
    // let dd = districts_.filter((d) => d.CodeDistrict == district_);
    let pageHeight = 0;
    // console.log(JSON.stringify(dd));

    let mydata2 = res;
    doc.setProperties({
      title: "Impression Ecole ",
      subject: "Liste des Inscrits ENI",
      author: "MENFP",
      keywords: "menfp, bunexe",
      creator: "BUNEXE",
    });

    var totalPagesExp = "{total_pages_count_string}";

    var pageHeight1 =
      doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
    var pageWidth1 =
      doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
    let xOffset =
      doc.internal.pageSize.width / 2 -
      (doc.getStringUnitWidth(titre_) * doc.internal.getFontSize()) / 2;
    let Tt =
      Math.ceil(doc.getStringUnitWidth(titre_) / 2) *
      doc.internal.getFontSize();
    // let str = '';

    doc.setFontSize(18);
    // doc.text('Dieu mon sujet de Gloire !!!', 14, 22);
    doc.setFontSize(11);
    doc.setTextColor(100);

    // jsPDF 1.4+ uses getWidth, <1.4 uses .width
    var pageSize = doc.internal.pageSize;
    var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
    // var text = 'Je suis celui qui vit par la grace de Dieu'; //doc.splitTextToSize(faker.lorem.sentence(45), pageWidth - 35, {})
    let str = "";
    // let pageHeight = 0;
    // doc.text(text, 14, 30);
    doc.autoTable({
      head: entete1,
      body: mydata2,
      startY: 50,
      showHead: "everyPage",
      didDrawPage: function (data) {
        doc.setFontSize(20);
        // doc.setTextColor(100);
        //LibelleSiege_temp;
        doc.text(
          titre_.trim().toUpperCase(),
          pageWidth1 / 2 - (titre_.trim().toUpperCase().length * 4.2) / 2,
          22,
        );
        doc.setFontSize(14);
        let pl = "Effectifs des Candidats par Ecole et Section";
        doc.text(
          pl.trim().toUpperCase(),
          pageWidth1 / 2 - (pl.trim().toUpperCase().length * 3.2) / 2,
          32,
        );
        doc.setFontSize(12);
        let An_ = "ENI / CAPISTE - 2021";
        doc.text(
          An_,
          pageWidth1 / 2 - (An_.trim().toUpperCase().length * 2.2) / 2,
          38,
        );

        //72, 38);

        doc.setFontSize(10);
        //   let serie__ = s.Libelle;
        // doc.text(s.section, 170, 48);
        // doc.text(`( ${gg.length} )`, 194, 48);

        //   doc.setFontSize(14);
        //   let Li_ = 'Liste des Inscrits';
        //   doc.text(Li_, pageWidth1 / 2 - (Li_.length * 3.0) / 2, 38);

        let Lig_ =
          "______________________________________________________________________";
        doc.text(Lig_, 20, 40);

        doc.setFontSize(12);
        //doc.text(k.trim(), 14, 48);

        doc.setFontSize(8);
        //let dz = `District :${dd[0].libelle_district.trim()}  ==> Zone :${zon_}`;
        //doc.text(dz, pageWidth1 / 2 - (dz.length * 2.4) / 2, 36);
        //doc.text(dz, 150, 48);

        doc.setFontSize(11);

        // doc.text(
        //   ecole_selection.Ecole.trim(),
        //   pageWidth1 / 2 - (ecole_selection.Ecole.length * 3.65) / 2,
        //   38
        // );

        // doc.text(k, 14, 30);
        str = "Page " + doc.internal.getNumberOfPages();
        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === "function") {
          str =
            str +
            " sur " +
            totalPagesExp +
            "     ===> Imprimé le " +
            new Date().toISOString();
        }
        doc.setFontSize(10);

        // jsPDF 1.4+ uses getWidth, <1.4 uses .width
        var pageSize = doc.internal.pageSize;
        pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      },
      margin: { top: 44 },
    });

    // Total page number plugin only available in jspdf v1.0+
    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }
    // doc.text(text, 14, doc.autoTable.previous.finalY + 10);
    // document.getElementById('output').src

    src_ = doc.output("datauristring");
    //alert(src_);
    setMysrc(src_);
    document.getElementById("download-link").href = src_;
    document.getElementById("output").data = doc.output("datauristring");
  };

  const EleveparSiege = async (d) => {
    setDisplayPrintArea(false);
    setStartLoading(true);
    try {
      // eni/liste_eleves_parsiege/001
      console.log("##########  ELeves par Siege");
      console.log(d);
      const res = await fetch(url_ + `/enic/liste_eleves_parsiege/${d}`);
      const parseData = await res.json();
      console.log(parseData);
      lesEleves = parseData;
      setEleves_(parseData);
      setStartLoading(false);
      setDisplayPrintArea(true);
      //console.log(lesEleves);

      //setZones_(parseData);

      !startLoading &&
        displayPrintArea &&
        setTimeout(() => {
          imprimable();
        }, 700);
    } catch (err) {
      console.error(err.message);
    }
  };

  const qteElevesParEcoleEtDept = async (d) => {
    setDisplayPrintArea(false);
    setStartLoading(true);
    try {
      // eni/liste_eleves_parsiege/001
      console.log("##########  ELeves par Siege");
      console.log(d);
      const res = await fetch(
        url_ + `/enic/${code_dept}/quantite_eleves_par_ecole`,
      );
      const parseData = await res.json();
      //console.log(parseData);
      //lesEleves = parseData;
      prepareData(parseData);
      console.log("#################");
      console.log(res);
      //lesEleves = parseData;
      //setEleves_(parseData);
      setStartLoading(false);
      setDisplayPrintArea(true);
      //console.log(lesEleves);

      //setZones_(parseData);

      !startLoading &&
        displayPrintArea &&
        setTimeout(() => {
          imprimable1();
        }, 700);
    } catch (err) {
      console.error(err.message);
    }
  };

  //   const parDistrictZone = async (d) => {
  //     setDisplayPrintArea(false);
  //     setEffectifsDistrict(0);
  //     setStartLoading(true);
  //     try {
  //       const res = await fetch(
  //         url_ + `/statistique/9af/${code_dept}/district/${d}`
  //       );
  //       const parseData = await res.json();
  //       setStartLoading(false);
  //       zone_temps = [...parseData];
  //       // console.log(zone_temps);
  //       setZones_(parseData);

  //       setEffectifsDistrict(
  //         zone_temps.reduce((acc, item) => (acc += item.qte), 0)
  //       );
  //     } catch (err) {
  //       console.error(err.message);
  //     }
  //   };

  const parSiege = async () => {
    setStartLoading(true);
    try {
      const res = await fetch(
        url_ + `/statistique/enic/${code_dept}/nombrecandidats_par_siege`,
      );
      const parseData = await res.json();
      setStartLoading(false);
      setSiege_(parseData[0].IDSIEGE);
      setSieges_(parseData);
      setEffectifSiege(
        parseData.reduce((acc, item) => (acc += item.qte_Eleves), 0),
      );
      console.log("====>", effectifSiege);
      console.log(sieges_);
    } catch (err) {
      console.error(err.message);
    }
  };

  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$

  const printTable = (z) => {
    //   console.log(`${district_}   ===> ${z}`);
    EleveparSiege(z.IDSIEGE);
    LibelleSiege_temp = z.DENOMSI;
    //   EleveparDistrictZone(z);
    zon_ = z;
  };

  const afficheEffectif = () => {
    qteElevesParEcoleEtDept();
  };

  //   const imprimable = () => {
  //     var doc = new jsPDF({ format: 'letter' });
  //     let dd = districts_.filter((d) => d.CodeDistrict == district_);
  //     let pageHeight = 0;
  //     console.log(JSON.stringify(dd));
  //     let mydata2 = lesEleves;
  //     doc.setProperties({
  //       title: 'Impression Ecole ',
  //       subject: 'Liste des Inscrits',
  //       author: 'MENFP',
  //       keywords: 'menfp, bunexe',
  //       creator: 'BUNEXE',
  //     });

  //     var totalPagesExp = '{total_pages_count_string}';

  //     var pageHeight1 =
  //       doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
  //     var pageWidth1 =
  //       doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
  //     let xOffset =
  //       doc.internal.pageSize.width / 2 -
  //       (doc.getStringUnitWidth(titre_) * doc.internal.getFontSize()) / 2;
  //     let Tt =
  //       Math.ceil(doc.getStringUnitWidth(titre_) / 2) *
  //       doc.internal.getFontSize();
  //     // let str = '';

  //     let r6 = mydata2.reduce((res, t) => {
  //       res[t.LibelleEt] = res[t.LibelleEt] ? [...res[t.LibelleEt], t] : [t];
  //       return res;
  //     }, []);
  //     let lignes = Object.keys(r6);
  //     doc.setFontSize(18);
  //     // doc.text('Dieu mon sujet de Gloire !!!', 14, 22);
  //     doc.setFontSize(11);
  //     doc.setTextColor(100);

  //     // jsPDF 1.4+ uses getWidth, <1.4 uses .width
  //     var pageSize = doc.internal.pageSize;
  //     var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
  //     // var text = 'Je suis celui qui vit par la grace de Dieu'; //doc.splitTextToSize(faker.lorem.sentence(45), pageWidth - 35, {})
  //     let str = '';
  //     // let pageHeight = 0;
  //     // doc.text(text, 14, 30);

  //     lignes.map((k) => {
  //       // doc.addPage();
  //       // doc.text(k + '  (' + r6[k][0].ecole + ')', 14, 30);
  //       // doc.text(r6[k][0].LibelleEt, 120, 30);
  //       // console.log(r6[k]);
  //       // doc.internal.
  //       doc.autoTable({
  //         head: entete,
  //         body: r6[k],
  //         startY: 50,
  //         showHead: 'everyPage',
  //         didDrawPage: function (data) {
  //           doc.setFontSize(20);
  //           // doc.setTextColor(100);
  //           doc.text(
  //             titre_.trim().toUpperCase(),
  //             pageWidth1 / 2 - (titre_.trim().toUpperCase().length * 4.2) / 2,
  //             22
  //           );
  //           doc.setFontSize(14);
  //           let An_ = 'NEUVIEME ANNEE FONDAMENTALE - 2020';
  //           doc.text(An_, pageWidth1 / 2 - (An_.length * 3.0) / 2, 30);

  //           doc.setFontSize(14);
  //           let Li_ = 'Liste des Inscrits';
  //           doc.text(Li_, pageWidth1 / 2 - (Li_.length * 3.0) / 2, 38);

  //           let Lig_ = '_______________________________________________________';
  //           doc.text(Lig_, pageWidth1 / 2 - (Lig_.length * 3.0) / 2, 40);

  //           doc.setFontSize(12);
  //           doc.text(k.trim(), 14, 48);

  //           doc.setFontSize(8);
  //           let dz = `District :${dd[0].libelle_district.trim()}  ==> Zone :${zon_}`;
  //           //doc.text(dz, pageWidth1 / 2 - (dz.length * 2.4) / 2, 36);
  //           doc.text(dz, 150, 48);

  //           doc.setFontSize(11);

  //           // doc.text(
  //           //   ecole_selection.Ecole.trim(),
  //           //   pageWidth1 / 2 - (ecole_selection.Ecole.length * 3.65) / 2,
  //           //   38
  //           // );

  //           // doc.text(k, 14, 30);
  //           str = 'Page ' + doc.internal.getNumberOfPages();
  //           // Total page number plugin only available in jspdf v1.0+
  //           if (typeof doc.putTotalPages === 'function') {
  //             str =
  //               str +
  //               ' of ' +
  //               totalPagesExp +
  //               '     ===> Imprimé le ' +
  //               new Date().toISOString();
  //           }
  //           doc.setFontSize(10);

  //           // jsPDF 1.4+ uses getWidth, <1.4 uses .width
  //           var pageSize = doc.internal.pageSize;
  //           pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
  //           doc.text(str, data.settings.margin.left, pageHeight - 10);
  //         },
  //         margin: { top: 44 },
  //       });
  //       doc.addPage();
  //     });
  //     // Total page number plugin only available in jspdf v1.0+
  //     if (typeof doc.putTotalPages === 'function') {
  //       doc.putTotalPages(totalPagesExp);
  //     }
  //     // doc.text(text, 14, doc.autoTable.previous.finalY + 10);
  //     // document.getElementById('output').src = doc.output('datauristring');
  //     document.getElementById('output').data = doc.output('datauristring');
  //   };

  //#################################################
  //   const handleChangeSelect = (n) => {
  //     setZones_([]);
  //     if (n.trim().length > 0) {
  //       setDistrict_(n);
  //       parDistrictZone(n);
  //     } else {
  //       setZones_([]);
  //     }
  //   };

  useEffect(() => {
    parSiege();
  }, []);

  return (
    <>
      {startLoading && (
        <div className="row">
          <div className="col-6 offset-col-3">
            <div className="d-flex justify-content-center">
              <h4>Patientez ....</h4>
              <Spinner animation="border" variant="info" />
            </div>
          </div>
        </div>
      )}
      <div className="row mt-4 mx-2">
        <div className="col-sm-12 col-md-3">
          {/*         
          <Form>
            <Form.Group controlId='formBasicEmail'>
              <Form.Label>District</Form.Label>
              <Form.Control
                as='select'
                custom
                value={district_}
                onChange={(e) => handleChangeSelect(e.target.value)}
              >
                <option value=''>Selectionner un district...</option>
                {districts_.map((d) => (
                  <option
                    key={d.CodeDistrict}
                    value={d.CodeDistrict}
                    className='py-4'
                  >
                    {d.libelle_district}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Form>
         */}
          <div className="container">
            {sieges_ && sieges_.length > 0 && (
              <>
                <button
                  className="btn btn-block btn-outline-info mb-4"
                  onClick={(e) => {
                    afficheEffectif();
                  }}
                >
                  {" "}
                  Effectifs par Ecole
                </button>
                <table className="table table-sm">
                  <thead>
                    <tr>
                      <th>Effectifs</th>
                      <th>{effectifSiege}</th>
                    </tr>
                    <tr>
                      {/* <th>IDSIEGE</th> */}
                      <th>Siège</th>
                      <th>Qte. Elèves</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sieges_.map((z) => (
                      <tr key={z.IDSIEGE}>
                        <td>{z.DENOMSI}</td>
                        <td>{z.qte_Eleves}</td>
                        <td>
                          <button
                            className="btn btn-small btn-primary mr-2"
                            onClick={(e) => printTable(z)}
                          >
                            <FaPrint size={14} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        </div>
        {displayPrintArea && (
          <div className="col-sm-12 col-md-8">
            <object
              id="output"
              type="application/pdf"
              width="100%"
              height="540px"
            >
              <p>
                <a href={`${mysrc}`} id="download-link">
                  Click here to download the PDF
                </a>
                .{`La Source est :${mysrc}`}
              </p>
            </object>
          </div>
        )}
      </div>
    </>
  );
};

export default Stats_par_siege;
